"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = {
    root: {
        display: "flex !important",
        justifyContent: "center",
        alignItems: "center",
        gap: "0.5rem",
        fontSize: "12px",
        fontWeight: 600,
        borderRadius: "7px",
        color: "#ffffff",
        background: "#175CD3",
        cursor: "pointer",
        outline: "none",
        transitionDuration: ".15s",
        transitionProperty: "color, background-color, border",
        transitionTimingFunction: "linear",
        border: "1px solid #D0D5DD",
        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
        padding: "0.375rem 1rem",
        // Disabled button appearance
        "&:disabled": {
            opacity: 0.5,
            cursor: "not-allowed",
        },
        "&.custom": {
            backgroundColor: "transparent",
        },
        // Active button appearance states
        "&.video-button--on": {
            color: "#B42318",
        },
        "&.video-button--off": {
            color: "#ff6565",
        },
        "&.video-button--active": {
            color: "#B42318",
        },
        "&.video-button--get-sound": {
            position: "absolute",
            zIndex: 130,
            left: 0,
        },
        // Button flex position helper
        "&.video-push-left": {
            marginLeft: "auto",
        },
        "&.video-push-right": {
            marginRight: "auto",
        },
        // lv styles
        // Active button appearance states
        "&.lv-button--on": {
            color: "#B42318",
        },
        "&.lv-button--off": {
            color: "#ff6565",
        },
        "&.lv-button--active": {
            backgroundColor: "#D31717",
            color: "#ffffff",
            border: "1px solid #D31717",
        },
        // Button flex position helper
        "&.lv-push-left": {
            marginLeft: "auto",
        },
        "&.lv-push-right": {
            marginRight: "auto",
        },
    },
};
exports.default = styles;
//# sourceMappingURL=styles.js.map